export const ACCOUNTING_SUBSECTION_PATHS = [
    "/chart-of-accounts",
    "/accounting/chart-of-accounts",
    "/counterparties",
    "/classes",
    "/reconciliation",
];

export const isChartOfAccountsRoute = (pathname: string): boolean =>
    pathname === "/chart-of-accounts" ||
    pathname === "/accounting/chart-of-accounts";
